// extracted by mini-css-extract-plugin
module.exports = {"tagLine":"tag-line_tagLine__3Chrc"};